import axios from "axios";
import { Button } from "@/components/ui/button";
import { MessageCircle, Smile } from "lucide-react";
import { toast } from "sonner";

const fmtDateTime = (d) =>
  new Date(d).toLocaleString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const MAX_DELAY_MS = 7 * 86400000;

const statusText = (trip) => {
  if (!trip.return_date) return "Cargá la fecha de regreso para programarla";
  if (!trip.post_reminder_enabled) return "Desactivada para este viaje";
  if (trip.post_reminder_sent_at) return `Enviada el ${fmtDateTime(trip.post_reminder_sent_at)}`;
  const due = new Date(trip.post_reminder_due_at).getTime();
  if (Date.now() > due + MAX_DELAY_MS) return `No enviada (vencía el ${fmtDateTime(trip.post_reminder_due_at)})`;
  if (Date.now() > due) return `Pendiente de envío (programada para el ${fmtDateTime(trip.post_reminder_due_at)})`;
  return `Programada para el ${fmtDateTime(trip.post_reminder_due_at)} · ${trip.post_reminder_hours_after || 48} h después del regreso`;
};

export const PostTripBar = ({ trip, client, api, axiosConfig, onChanged }) => {
  const phone = (client?.phone || "").replace(/\D/g, "");
  const waPending = trip.post_reminder_sent_at && !trip.post_reminder_whatsapp_sent_at && phone;

  const sendWhatsApp = async () => {
    try {
      const res = await axios.get(`${api}/trips/${trip.id}/post-reminder/preview`, axiosConfig);
      // api.whatsapp.com keeps emojis intact (wa.me's redirect corrupts them)
      window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(res.data.message)}`, "_blank", "noopener,noreferrer");
      await axios.post(`${api}/trips/${trip.id}/post-reminder/mark-whatsapp-sent`, {}, axiosConfig);
      toast.success("WhatsApp abierto — encuesta marcada como enviada");
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al abrir WhatsApp");
    }
  };

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap mb-4 rounded-xl bg-amber-50/50 border border-amber-100 px-4 py-2.5" data-testid="post-trip-bar">
      <p className="text-sm text-sky-900 flex items-center gap-2">
        <Smile className="w-4 h-4 text-amber-500 shrink-0" />
        <span>
          <strong>Encuesta post viaje:</strong>{" "}
          <span data-testid="post-trip-status">{statusText(trip)}</span>
          {trip.post_reminder_whatsapp_sent_at && " · WhatsApp enviado"}
        </span>
      </p>
      {waPending && (
        <Button size="sm" onClick={sendWhatsApp} className="bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="post-trip-whatsapp-button">
          <MessageCircle className="w-4 h-4 mr-1" />
          Enviar por WhatsApp
        </Button>
      )}
    </div>
  );
};
